import React from "react";
import { Route } from "react-router";
import TrucksLandingPage from "pages/Trucks/TrucksLandingPage/TrucksLandingPage";
import CreateTrucksPage from "pages/Trucks/CreateTrucksPage/CreateTrucksPage";
import AddOrdersPage from "pages/Trucks/AddOrdersPage/AddOrdersPage";
import ReviewTrucksPage from "pages/Trucks/ReviewTrucksPage/ReviewTrucksPage";
import TrucksConfirmationPage from "pages/Trucks/TrucksConfirmationPage/TrucksConfirmationPage";
import TruckFormProvider from "components/Trucks/TrucksFormProvider";
import { ProtectedRoute } from "./ProtectedRoute";
import { UserNavigationGroup, UserRole } from "../types/declarations/enums.ts";

export const TrucksRoutes = ProtectedRoute({
	path: "trucks",
	blackListNavGroupWithRoles: {
		[UserNavigationGroup.QUOTER]: [UserRole.USER]
	},
	children: (
		<>
			<Route
				index
				element={<TrucksLandingPage />}
			/>
			<Route
				path="create-truck"
				element={
					<TruckFormProvider>
						<CreateTrucksPage />
					</TruckFormProvider>
				}
			/>
			<Route
				path="add-order"
				element={<AddOrdersPage />}
			/>
			<Route
				path="review"
				element={<ReviewTrucksPage />}
			/>
			<Route
				path="confirmation"
				element={<TrucksConfirmationPage />}
			/>
		</>
	)
});
